import { IVectorData } from 'xyzt';

/**
 *
 * @collboard-modules-sdk
 */
export function pointsToPolygon(points: Array<IVectorData>) {
    return points.map((point) => point.x + ',' + point.y).join(' ');
}
